import styled from 'styled-components';
import { ImageCard as RawImageCard } from 'components/ImageCard';
import { SectionWrapper as RawSectionWrapper } from 'components/SectionWrapper';

import {
  colors,
  typography,
  size,
  mediaQueries,
  InfoBlock as InfoBlockBase,
  Col as RawCol,
} from '@everlywell/leaves';

export const SectionWrapper = styled(RawSectionWrapper)`
  padding-top: 34px;
  padding-bottom: ${size.xs1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-top: 100px;
    padding-bottom: ${size.xl1}px;
  }
`;

const SectionHeadline = styled.h2`
  ${typography.h1Text}
  color: ${colors.teal4};
  margin-bottom: ${size.xl1}px;
  text-align: center;
  font-weight: ${typography.weight.bold};

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: 68px;
  }
`;

const ImageCard = styled(RawImageCard)`
  flex-direction: column;
  width: 100%;
  max-width: 620px;
  margin: ${size.lg}px auto;

  ${mediaQueries.forDesktopUp} {
    max-width: 100%;
  }

  .gatsby-image-wrapper {
    width: unset;
    height: unset;
    min-width: unset;
    max-width: inherit;
    min-height: unset;
    max-height: 381px;
  }

  & > div:nth-child(2) {
    padding: ${size.lg}px;
    > div {
      overflow: hidden;
      max-height: 186px;
    }
  }

  p {
    font-weight: ${typography.weight.book};
    letter-spacing: 0;
  }

  ${mediaQueries.forTabletHorizontalUp} {
    & > div:nth-child(2) {
      padding: 36px 61px 36px 48px;
      > div {
        max-height: 134px;
      }
    }

    h2 {
      margin-bottom: 20px;
      ${typography.h5Text}
    }
  }
`;

const SectionSubheadline = styled.p`
  ${typography.bodyText}
  color: ${colors.gray4};
  margin-bottom: ${size.xl1}px;
  text-align: left;
  ${mediaQueries.forTabletHorizontalUp} {
    text-align: center;
    margin-bottom: ${size.xl4}px;
  }
`;

const InfoBlock = styled(InfoBlockBase).attrs((props) => ({
  imageAlt: props.imageAlt,
}))`
  margin-bottom: ${size.xl1}px;

  ${mediaQueries.forTabletHorizontalUp} {
    margin-bottom: 0;
  }
`;

const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${mediaQueries.forTabletHorizontalUp} {
    flex-direction: row;
    gap: ${size.lg}px;
  }
`;

const Description = styled.p`
  ${typography.bodyText}
`;

const Col = styled(RawCol)`
  display: flex;
  justify-content: center;
`;

export {
  SectionHeadline,
  SectionSubheadline,
  CardContainer,
  InfoBlock,
  Description,
  Col,
  ImageCard,
};
